<template>
  <div>
    <DailyScheduleItem
      v-for="childCourse in orderedChildCourses"
      :key="childCourse.id"
      :lesson="childCourse"
      type="monthly"
      @click="handleClickScheduleItem"
    />

    <div
      v-if="childCourses.length > 2"
      class="more-schedule"
    >
      그 외 {{ childCourses.length - 2 }}개
    </div>
  </div>
</template>

<script>
import DailyScheduleItem from "./DailyScheduleItem";
export default {
	name: "DailySchedulesInMonth",
	components: { DailyScheduleItem },
	props: {
		childCourses: {
			type: Array,
			default: [],
		},
	},
	computed: {
		orderedChildCourses() {
			return _.take(_.orderBy(this.childCourses, ["dt"], ["asc"]), 2);
		},
	},
	methods: {
		handleClickScheduleItem(schedule) {
			this.$emit("select", schedule);
		},
	},
};
</script>

<style lang="scss">
</style>
